import { useSelector } from "react-redux";
import { RootState } from "@store/index";

export function DominantColor() : string{
    const dominantColor: any = useSelector(
        (State: RootState): string => State.colorSlice.dominantColor
    );
    return dominantColor;
}
